module.exports = __webpack_public_path__ + "static/assets/c318b444e8654503e287337206a770b1.png";